import React, { useState } from 'react';
import { MdLock, MdClose, MdSave, MdVisibility, MdVisibilityOff } from 'react-icons/md';
import api from '../api/axios';
import { useAuth } from '../context/AuthContext';

const ChangePasswordModal = ({ open, onClose, forced = false }) => {
  const { setSession, logout } = useAuth();
  const [current, setCurrent] = useState('');
  const [next1, setNext1] = useState('');
  const [next2, setNext2] = useState('');
  const [show, setShow] = useState(false);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  if (!open) return null;

  const reset = () => { setCurrent(''); setNext1(''); setNext2(''); setErr(''); setDone(false); };

  const submit = async (e) => {
    e?.preventDefault();
    setErr('');
    if (next1.length < 8)        return setErr('New password must be at least 8 characters');
    if (next1 !== next2)         return setErr('New passwords do not match');
    if (next1 === current)       return setErr('New password must differ from current');

    setBusy(true);
    try {
      const res = await api.post('/auth/change-password', {
        current_password: current,
        new_password: next1,
      });
      setSession(res.data.token, res.data.user);
      setDone(true);
      setTimeout(() => { reset(); onClose(); }, 800);
    } catch (e) {
      setErr(e.response?.data?.error || 'Change failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000,
    }}>
      <div style={{
        background: 'white', borderRadius: 10, padding: 24, width: 460, maxWidth: '92%',
        boxShadow: '0 12px 40px rgba(0,0,0,0.25)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
          <MdLock style={{ fontSize: 26, color: '#1a3c6e' }} />
          <h3 style={{ margin: 0 }}>{forced ? 'Set a new password' : 'Change Password'}</h3>
          {!forced && (
            <button onClick={onClose}
              style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', fontSize: 22, color: '#888' }}>
              <MdClose />
            </button>
          )}
        </div>

        {forced && (
          <div style={{
            background: '#fff8e1', border: '1px solid #ffe082',
            borderRadius: 6, padding: 10, fontSize: 13, color: '#7a5400', marginBottom: 12,
          }}>
            ⚠ An administrator requires you to set a new password before continuing.
          </div>
        )}

        {done ? (
          <div style={{ padding: 12, background: '#e8f5e9', color: '#2e7d32', borderRadius: 6, textAlign: 'center' }}>
            ✓ Password updated successfully
          </div>
        ) : (
          <form onSubmit={submit}>
            <PasswordField label="Current password" value={current} onChange={setCurrent} show={show} />
            <PasswordField label="New password (min 8 chars)" value={next1} onChange={setNext1} show={show} />
            <PasswordField label="Confirm new password" value={next2} onChange={setNext2} show={show} />

            <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#666', marginBottom: 12, cursor: 'pointer' }}>
              <input type="checkbox" checked={show} onChange={e => setShow(e.target.checked)} />
              <span>{show ? <MdVisibility /> : <MdVisibilityOff />} Show passwords</span>
            </label>

            {err && (
              <div style={{
                background: '#ffebee', border: '1px solid #ffcdd2', color: '#c62828',
                padding: '8px 10px', borderRadius: 6, fontSize: 13, marginBottom: 12,
              }}>⚠ {err}</div>
            )}

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              {forced ? (
                <button type="button" className="btn btn-outline" onClick={() => { logout(); window.location.href = `${process.env.PUBLIC_URL || ''}/login`; }}>
                  Log out instead
                </button>
              ) : (
                <button type="button" className="btn btn-outline" onClick={onClose} disabled={busy}>Cancel</button>
              )}
              <button type="submit" className="btn btn-primary" disabled={busy}>
                <MdSave /> {busy ? 'Updating…' : 'Update Password'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

const PasswordField = ({ label, value, onChange, show }) => (
  <div style={{ marginBottom: 12 }}>
    <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>{label}</label>
    <input
      type={show ? 'text' : 'password'}
      value={value}
      onChange={e => onChange(e.target.value)}
      autoComplete="off"
      style={{
        width: '100%', padding: '10px 12px', borderRadius: 6,
        border: '1px solid #ccc', fontSize: 14, boxSizing: 'border-box',
      }}
    />
  </div>
);

export default ChangePasswordModal;
